/** Matches PublicInterface.Shared.ErrorResponseDto */
export interface ErrorResponse {
	errorCode: string;
	errorMessages: string[];
	errorData: unknown;
}

/** API service error — wraps a parsed error response from the backend */
export class ApiServiceError extends Error {
	readonly errorCode: string;
	readonly errorMessages: string[];
	readonly errorData: unknown;

	constructor(response: ErrorResponse) {
		const message = response.errorMessages.join(' | ') || response.errorCode;
		super(message);
		this.name = 'ApiServiceError';
		this.errorCode = response.errorCode;
		this.errorMessages = response.errorMessages;
		this.errorData = response.errorData;
	}
}

/** Thrown on HTTP 401 — triggers automatic logout */
export class ApiAuthenticationError extends Error {
	readonly errorCode = 'AuthenticationError';

	constructor(message = 'Unauthorized') {
		super(message);
		this.name = 'ApiAuthenticationError';
	}
}

/** Thrown on HTTP 426 — app version mismatch */
export class ApiVersionMismatchError extends Error {
	constructor() {
		super('Version mismatch — please reload the application');
		this.name = 'ApiVersionMismatchError';
	}
}

/** Thrown on HTTP 423 — the account is blocked */
export class ApiAccountBlockedError extends Error {
	constructor() {
		super('Account is blocked');
		this.name = 'ApiAccountBlockedError';
	}
}

/** Thrown when the network request itself fails */
export class ApiNetworkError extends Error {
	constructor(cause: unknown) {
		super('Network request failed');
		this.name = 'ApiNetworkError';
		this.cause = cause;
	}
}
